export const metricColors = {
	riskScore: {
		0: '#F1F6FF',
		1: '#6FDAA5',
		2: '#FFB907',
		3: '#F54E4E',
		4: '#F54E4E',
	},
	validation: 'rgba(245, 78, 78, 0.05)',
};

export const statuses = {
	pending: 'pending',
	approved: 'approved',
	rejected: 'rejected',
	noUplift: 'noUplift',
	intermediate_approved : 'intermediate_approved',
	intermediate_rejected: 'intermediate_rejected',
};

export const JobTiersDefaultIncrease = {
	1: 0,
	2: 5,
	3: 10,
};

export const RateEscalationStatuses = {
	APPROVED: 'approved',
	PENDING: 'pending',
	REJECTED: 'rejected',
	NO_UPLIFT: 'noUplift',
	CANCELLED: 'cancelled',
	INTERMEDIATE_APPROVED: 'intermediate_approved',
	INTERMEDIATE_REJECTED: 'intermediate_rejected',
};

export const riskStatuces = {
	MITIGATED: 'mitigated',
	NON_MITIGATED: 'nonMitigatable',
};

export const RateTableColumns = [
	{ key: 'title', label: 'role' },
	{ key: 'grade', label: 'band' },
	{ key: 'area', label: 'department' },
	{
		key: 'tier', label: 'tier', thClass: 'center', tdClass: 'center',
	},
	{ key: 'fulfillment', label: 'fulfillment' },
	{ key: 'thresholdFactor', label: 'metrics' },
	{ key: 'increase', label: 'Increase Value' },
	{
		key: 'comments', label: 'comments', thClass: 'center', tdClass: 'center',
	},
	{
		key: 'suggest', label: 'suggest', thClass: 'center', tdClass: 'center',
	},
];

export const RateTableValues = {
	TITLE: 'title',
	GRADE: 'grade',
	AREA: 'area',
	TIER: 'tier',
	FULFILLMENT: 'fulfillment',
	THRESHOLD_FACTOR: 'thresholdFactor',
	INCREASE: 'increase',
	COMMENTS: 'comments',
	SUGGEST: 'suggest',
};
